<div *ngIf="entity">
  <h2>{{ viewContext.entityNamePlural | titlecase}} / {{ entity.name | uppercase }}</h2>
  <div>
    <form (ngSubmit)="onSubmit()" [formGroup]="form">

      <div *ngFor="let question of questions" class="form-row">
        <div class="form-group col-xl-10">
          <app-question [question]="question" [form]="form"></app-question>
        </div>
      </div>
    </form>

    <ngb-accordion [destroyOnHide]="false" #acc="ngbAccordion">
      <ngb-panel title="Read rights">
        <ng-template ngbPanelContent>
          <app-rights-selection
            [rightTargets]="selectedReadGroupsFromRest"
            (idsChanged)="readGroupIdsChanged($event)"
          >
          </app-rights-selection>
        </ng-template>
      </ngb-panel>

      <ngb-panel title="Write rights">
        <ng-template ngbPanelContent>
          <app-rights-selection
            [rightTargets]="selectedWriteGroupsFromRest"
            (idsChanged)="writeGroupIdsChanged($event)"
          >
          </app-rights-selection>
        </ng-template>
      </ngb-panel>

      <ngb-panel title="Additional rights">
        <ng-template ngbPanelContent>
          <app-rights-selection
            [rightTargets]="selectedUiGroupsFromRest"
            (idsChanged)="uiIdsChanged($event)"
            [additionalRights]="true"
          >
          </app-rights-selection>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>


    <app-buttons [buttons]="getButtonsMeta()"
                 (buttonPressed)="controlButtonPressed($event)"
                 [targetSelected]="true">
    </app-buttons>
  </div>
</div>
